import http from './http'
import Resource from './resource'

const path = 'admin/tournaments'

class Tournaments extends Resource {
  constructor(_http) {
    super(path, _http)
  }
}

const TournamentsRequest = new Tournaments(http)

export default TournamentsRequest
